import React, { useEffect, useCallback, useRef } from "react";
import NotificationAlert from "react-notification-alert";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useParams, useHistory } from "react-router-dom";
import { fetchProduit } from "../../Redux/produitReduce";
import { fetchGrossisteSite } from "../../Redux/grossisteReduce";
import { simulationCAdded } from "../../Redux/simulationCReduce";
import Select from "react-select";
import { useDispatch } from "react-redux";

function AjouterSimulationC({ client }) {
  const dispatch = useDispatch();
  const location = useParams();
  const navigate = useHistory();
  const saveCalled = useRef(false);
  const [loading, setLoading] = React.useState(false);


  document.title = isNaN(location.id) ? "Ajouter Simulation" : "Modifier le Simulation";

  const [produitsData, setProduitsData] = React.useState([]);
  const [typeSelectGlobal, setTypeSelectGlobal] = React.useState(null);
  const [optionProduit, setOptionProduit] = React.useState([]);
  const [optionsType] = React.useState([
    { value: "repartition", label: "repartition" },
    { value: "mise en place", label: "mise en place" },
    { value: "arrivage", label: "arrivage" },
  ]);
  const [date1, setDate1] = React.useState(null);
  const [date2, setDate2] = React.useState(null);
  const [date3, setDate3] = React.useState(null);
  const [alert, setAlert] = React.useState(null);

  const notificationAlertRef = React.useRef(null);
  const notify = (place, msg, type) => {
    const options = {
      place,
      message: <div><div>{msg}</div></div>,
      type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const getproduit = useCallback(async () => {
    const response = await dispatch(fetchProduit({ client }));
    const entities = response.payload;
    const arrayOption = entities.map(e => ({ value: e.id, label: e.Designation_1, code_pct: e.Code_PCT,prix:e.Prix,colisage:e.Coefficient_UC }));
    setOptionProduit(arrayOption);
  }, [dispatch, client]);

  const ajouterProduit = () => {
    setProduitsData([...produitsData, {
      produit: null,
      quantite: 0,
      prix: 0,
      colisage: 0,
      entities: []
    }]);
  };

  const handleProduitChange = async (index, selectedProduit) => {
    const newProduits = [...produitsData];
    newProduits[index].produit = selectedProduit;
    setProduitsData(newProduits);

    await handleGrossiste(index, client);
  };


  // const handleQuantiteProduitChange = async (index, qteValue, client) => {
  //   const newProduits = [...produitsData];

  //   const entities = newProduits[index].entities.map(g => ({
  //      ...g,
  //     quantite: Math.round((qteValue * (g.quota ?? 0)) / 100)
  //       }));


  //   newProduits[index].quantite = qteValue;
  //   newProduits[index].entities = entities;
  //   setProduitsData(newProduits);
  // };

  const handleQuantiteProduitChange = (index, qteValue) => {
    const value = Math.max(0, Number(qteValue) || 0); // Pas de négatifs ni NaN

    setProduitsData(prev => {
      const updated = [...prev];

      const entities = updated[index].entities.map(g => ({
        ...g,
        quantite: Math.round((value * (g.quota ?? 0)) / 100)
      }));

      updated[index] = {
        ...updated[index],
        quantite: value,
        entities
      };

      return updated;
    });
  };


  // const handleGrossiste = async (index, client) => {
  //   const response = await dispatch(fetchGrossisteSite({ client }));

  //   const grossistes = response.payload;
  //   const clientQuota = client === "/medis" ? "quota_indestrie2" : "quota_indestrie3";

  //   const entities = grossistes.map(g => ({
  //     id_grossiste: g.grossistes.id,
  //     raison_sociale: g.grossistes.Raison_sociale,
  //     quota: g.grossistes[clientQuota] ?? 0,
  //     quantite: 0,
  //   }));
  //   const newProduits = [...produitsData];
  //   newProduits[index].entities = entities;
  //   setProduitsData(newProduits);
  // };

  const handleGrossiste = async (index, client) => {
    const response = await dispatch(fetchGrossisteSite({ client }));
    const grossistes = response.payload;

    const clientQuota = client === "/medis"
      ? "quota_indestrie2"
      : "quota_indestrie3";

    const entities = grossistes.map(g => ({
      id_grossiste: g.grossistes.id,
      raison_sociale: g.grossistes.Raison_sociale,
      quota: g.grossistes[clientQuota] ?? 0,
      quantite: 0,
    }));

    setProduitsData(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        entities,
      };
      return updated;
    });
  };

  const handleQuantiteGrossisteChange = (prodIndex, grossisteIndex, value) => {
    const newProduits = [...produitsData];
    newProduits[prodIndex].entities[grossisteIndex].quantite = parseFloat(value) || 0;
    setProduitsData(newProduits);
  };

  function submitForm() {
    if (!typeSelectGlobal) {
      notify("tr", "Le type est obligatoire", "danger");
      return;
    }

    if (produitsData.length === 0) {
      notify("tr", "Veuillez ajouter au moins un produit", "danger");
      return;
    }

    const payload = produitsData.map(p => ({
      id_produit: p.produit?.value,
      nom_produit: p.produit?.label,
      code_pct: p.produit?.code_pct,
      colisage: p.produit?.colisage,
      prix: p.produit?.prix,
      quantite: p.quantite,
      entities: p.entities,
    }));

    if (saveCalled.current) return;
    saveCalled.current = true;
    setLoading(true);
    dispatch(simulationCAdded({ client, id: 0, type: typeSelectGlobal?.value, produits: payload, date1, date2, date3 }))
      .then(e => {
        if (e.payload === true) {
          notify("tr", "Insertion avec succès", "success");
          setTimeout(() => listeSimulationC(), 1000);
        } else {
          saveCalled.current = false;
          setLoading(false);
          notify("tr", "Problème de connexion", "danger");
        }
      });
  }

  const listeSimulationC = () => {
    navigate.push(client + "/listSimulationC");
  };

  useEffect(() => {
    getproduit();
  }, []);

  return (
    <Container fluid>
      {alert}
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Button variant="info" className="mb-3" onClick={listeSimulationC}>
        <i className="fas fa-list"></i> Retour à la liste
      </Button>
      <Card className="mb-4">
        <Card.Body>
          <Row>
            <Col md="6">
              <label>Type *</label>
              <Select
                value={typeSelectGlobal}
                onChange={setTypeSelectGlobal}
                options={optionsType}
              />
            </Col>
          </Row>

          <Row className="mt-4">
            <Col md="4">
              <Form.Group>
                <label>Date1</label>
                <Form.Control type="date" value={date1} onChange={(e) => setDate1(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group>
                <label>Date2</label>
                <Form.Control type="date" value={date2} onChange={(e) => setDate2(e.target.value)} />
              </Form.Group>
            </Col>
            {/* <Col md="4">
              <Form.Group>
                <label>Date3</label>
                <Form.Control type="date" value={date3} onChange={(e) => setDate3(e.target.value)} />
              </Form.Group>
            </Col> */}
          </Row>


        </Card.Body></Card>



      {produitsData.map((prod, index) => (
        <Card key={index} className="mb-4">
          <Card.Body>
            <Row>
              <Col md="6">
                <label>Produit</label>
                <Select
                  value={prod.produit}
                  onChange={(v) => handleProduitChange(index, v)}
                  options={optionProduit}
                />
              </Col>
              <Col md="6">
                <label>Quantité totale</label>
                <Form.Control
                  type="number"
                  value={prod.quantite}
                  onChange={(e) => handleQuantiteProduitChange(index, parseFloat(e.target.value), client)}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col md="12">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Grossiste</th>
                      <th>Quota</th>
                      <th>Quantité</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prod.entities.map((ent, i) => (
                      <tr key={i}>
                        <td>{ent.raison_sociale}</td>
                        <td>{ent.quota}</td>
                        <td>
                          <Form.Control
                            type="number"
                            value={ent.quantite}
                            onChange={(e) => handleQuantiteGrossisteChange(index, i, e.target.value)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}
      <br></br>
      <Button variant="secondary" className="mb-3 mt-3" onClick={ajouterProduit}>
        Ajouter Produit
      </Button>
      <br></br><br></br>
      {loading ? (
        <>
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          Enregistrement en cours...
        </>
      ) :
        (<Button variant="info" className="mt-4" onClick={submitForm}>
          Enregistrer
        </Button>)}
    </Container>
  );
}

export default AjouterSimulationC;
